<template>
  <v-chip
    :prepend-icon="hasIssue ? 'mdi-alert-circle' : undefined"
    append-icon="mdi-chevron-down"
    size="small"
    variant="outlined"
    :color="hasIssue ? 'error' : '#656565'"
    class="ml-auto"
    @click="handleClick"
    style="cursor: pointer">
    <span v-if="hasIssue" class="typography-caption-bold text--color-error-60">
      Issue resolved?
    </span>
    <span v-else class="typography-caption-bold text--color-neutral-90">Any issues?</span>
  </v-chip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useDialogTrigger } from '@/composables';
import { YardTaskFlags } from '@nova/core';

const props = defineProps<{
  taskId: string;
  type: 'move' | 'check-asset' | 'check-spot' | 'check-area';
  tags?: YardTaskFlags[];
  onIssueReported?: (comment: string) => void;
  onIssueCleared?: () => void;
}>();

const reportIssueDialog = useDialogTrigger('open-report-issue-dialog');
const clearIssueDialog = useDialogTrigger('open-clear-issue-dialog');

const hasIssue = computed(() => {
  if (!Array.isArray(props.tags)) {
    return false;
  }
  return props.tags.includes(YardTaskFlags.ISSUE);
});

const handleClick = () => {
  if (hasIssue.value) {
    openClearIssueDialog();
  } else {
    openReportIssueDialog();
  }
};

const openReportIssueDialog = () => {
  reportIssueDialog.triggerDialog({
    taskId: props.taskId,
    type: props.type,
    tags: props.tags,
    onIssueReported: props.onIssueReported
  });
};

const openClearIssueDialog = () => {
  clearIssueDialog.triggerDialog({
    taskId: props.taskId,
    type: props.type,
    tags: props.tags,
    onIssueCleared: props.onIssueCleared
  });
};
</script>
